@for (section of form().groups; track section) {
  <div class="app-section">
    <h3> {{ section.name }}</h3>
    <br>
    <ul>
      @for (item of section?.fields; track item; let i = $index) {
        <li>
          <app-form-permissions-item [index]="i" [itemForm]="item" />
        </li>
      }
    </ul>
  </div>
}
@for (field of form().fields; track field) {
  <div class="app-section">
    <app-form-permissions-item [index]="0" [itemForm]="field" />
  </div>
}
@for (table of form().tables; track table) {
  <div class="app-section">
    <h3> {{ table.name }}</h3>
    <br>
    <div class="flex-row-grow left-center">
      @for (col of table?.columns; track col; let i = $index) {
        <app-column [index]="i" [columnForm]="col" />
      }
    </div>
  </div>
}

@for (drawing of form().drawings; track drawing) {
  <div class="app-section flex-row-grow space-between-center">
    <mat-icon>draw</mat-icon>
    <h2>{{ drawing.name }}</h2>
    <p>{{ drawing.renderTag }}</p>
  </div>
}
@for (attachment of form().attachments; track attachment) {
  <div class="app-section flex-row-grow space-between-center">
    <mat-icon>attachment</mat-icon>
    <h2>{{ attachment.name }}</h2>
    <p>{{ attachment.renderTag }}</p>
  </div>
}
@for (attachmentGroup of form().attachmentGroups; track attachmentGroup) {
  <div class="app-section">
    <div class="flex-col-grow center-stretch">
      <div class="flex-row-grow space-between-center">
        <h2>{{ attachmentGroup.name }}</h2>
        <p>{{ attachmentGroup.renderTag }}</p>
      </div>
      @for (att of attachmentGroup.attachments; track att) {
        <div class="flex-row-grow space-between-center">
          <mat-icon>attachment</mat-icon>
          <h2>{{ att.name }}</h2>
          <p>{{ att.renderTag }}</p>
        </div>
      }
    </div>
  </div>
}
@for (iAttachmentGroup of form().interactiveAttachmentGroups; track iAttachmentGroup) {
  <div class="app-section">
    <div class="flex-col-grow center-stretch">
      <div class="flex-row-grow space-between-center">
        <h2>{{ iAttachmentGroup.name }}</h2>
        <p>{{ iAttachmentGroup.renderTag }}</p>
      </div>
      @for (att of iAttachmentGroup.attachments; track att) {
        <div class="flex-row-grow space-between-center">
          <mat-icon>attachment</mat-icon>
          <h2>{{ att.name }}</h2>
          <p>{{ att.renderTag }}</p>
        </div>
      }
    </div>
  </div>
}
@for (dAttachmentGroup of form().deviceAttachmentGroups; track dAttachmentGroup) {
  <div class="app-section">
    <div class="flex-col-grow center-stretch">
      <div class="flex-row-grow space-between-center">
        <h2>{{ dAttachmentGroup.name }}</h2>
        <p>{{ dAttachmentGroup.renderTag }}</p>
      </div>
      @for (att of dAttachmentGroup.attachments; track att) {
        <div class="flex-row-grow space-between-center">
          <mat-icon>attachment</mat-icon>
          <h2>{{ att.name }}</h2>
          <p>{{ att.renderTag }}</p>
        </div>
      }
    </div>
  </div>
}

@for (sign of form().signatures; track sign) {
  <div class="app-section selectionflex-row-grow space-between-center">
    <mat-icon>gesture</mat-icon>
    <h2>{{ sign.name }}</h2>
    <p>{{ sign.renderTag }}</p>
  </div>
}


